// extracted by mini-css-extract-plugin
export default {"wrapper":"Layout_wrapper__mtAb6","layout":"Layout_layout__3kurR","ani":"Layout_ani__aLGWV"};